






























































































	import {Prop, Watch} from "vue-property-decorator";
	import {Stored} from 'vue-stored-prop-decorator';
	import {Component, Vue} from '@/shared/component';
	import {Timeout, WatchObjectProperties} from '@/shared/decorator';

	import storeVente, {VenteFilter} from '@/stores/modules/vente';
	import storeTransporteur from "@/stores/modules/transporteur";
	import storeClient from "@/stores/modules/client";

	import InputDateFilter from '@/components/Input/DateFilter.vue';
	import CrudClientSearch from "@/components/Crud/Client/Search.vue";
	import CrudTransporteurSearch from "@/components/Crud/Transporteur/Search.vue";
	import InputBoisType from "@/components/Input/BoisType.vue";
	import InputLongueursVente from "@/components/Input/LongueursVente.vue";
	import {DateFilterMode} from "@/shared/filter";
	import storeFournisseur from "@/stores/modules/fournisseur";

	@Component({
		components: {
			InputDateFilter,
			CrudClientSearch,
			InputBoisType,
			InputLongueursVente,
			CrudTransporteurSearch,
		}
	})
	export default class CrudVenteFilter extends Vue {

		@Prop({ type: Boolean, default: false}) reduce!: boolean;

		@Stored(() => storeVente) private page!: number;
		@Stored(() => storeVente) private filters!: VenteFilter;

		private storeTransporteur = storeTransporteur
		private storeClient = storeClient

		private valueClient = null;
		private valueTransporteur = null;

		@WatchObjectProperties('filters', VenteFilter)
		@Timeout()
		private filtersWatcher(): void {
			this.page = 0;
			storeVente.dispatch('getC', { filters: true });
		}

		public async mounted(): Promise<void> {
			await storeTransporteur.dispatch('getAll');
			this.valueTransporteur = storeTransporteur.state.all.data
			await storeClient.dispatch('getAll');
			this.valueClient = storeClient.state.all.data
		    this.typeWatcher();
			this.filters = new VenteFilter();
			var dt = new Date();
			dt.setDate(dt.getDate() - 90);
			this.filters.date.start = dt;
			this.filters.date.end = new Date();
			this.filters.date.mode = DateFilterMode.RANGE;
		}

	    @Watch('type')
		private typeWatcher(): void {
            this.filters.clear();

		}
		
	}
